import { formatInTimeZone } from "date-fns-tz";

const isoFormat = "yyyy-MM-dd";

export default function getRomanianDate(date: Date | string) {
  const timeZone = "Europe/Bucharest";

  return formatInTimeZone(date, timeZone, isoFormat);
}
